import React from "react";
import LandingInterface from "../../../interfaces/landing/LandingInterface";
import Landing from "../../landing/Landing";

interface LandingProps {
    landings: LandingInterface[];
}

const LandingContent: React.FC<LandingProps> = ({landings}) => {
    return (
        <div className="landing-page">
            {landings.map((landing: LandingInterface) => {
                const hasBannerRepository = landing?.items?.some(
                    (item) => item.type === 'landing-banner-repository'
                ) && landing?.items?.length === 1;
                const landingClass = hasBannerRepository ? "landing landingFull" : "landing";
                return (
                    <div className={landingClass} key={landing.id}>
                        <Landing landingItems={landing.items} error={""} />
                    </div>
                );
            })}
        </div>
    );
};

export default LandingContent;
